export default {
  common: {
    loadFailed: "加载失败，请重试",
    saveFailed: "保存失败，请重试",
    refresh: '刷新',
    search: '查询',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    disable: '禁用',
    view: '查看',
    share: '分享',
    shared: '共享',
    revoke: '撤销',
    authorize: '授权',
    actions: '操作',
    all: '全部',
    readOnly: '只读',
    collaboration: '协作',
    normal: '正常',
    disabled: '禁用',
    enabled: '开启',
    closed: '关闭',
    noData: '暂无数据',
    notFilled: '未填写',
    unassigned: '未分配',
    unknownOrganization: '未知组织',
    selectOrganization: '选择组织',
    includeChildren: '包含下级',
    description: '描述',
    remarks: '备注',
    organization: '组织',
    owningOrganization: '所属组织',
    loginName: '登录名',
    nickname: '昵称',
    phone: '手机号',
    role: '角色',
    status: '状态',
    permission: '权限',
    validThrough: '有效期',
    device: '设备',
    deviceName: '设备名称',
    chipId: '芯片编号',
    deviceType: '设备类型',
    hardwareVersion: '硬件版本',
    softwareVersion: '软件版本',
    type: '类型',
    owner: '所有者',
    deviceKeywordPlaceholder: '设备名称、描述或芯片编号',
    selectUser: '请选择人员',
    saveSuccess: '保存成功',
    authorizationSuccess: '授权成功',
    operationConfirm: '操作确认',
    revoked: '已撤销'
  },
  theme: {
    title: '组织主题',
    keywordPlaceholder: '主题名称、描述或 FourCC',
    themeName: '主题名称',
    editTitle: '编辑主题元数据',
    shareTitle: '主题分享',
    exactPhone: '输入完整手机号，海外号码请带国家区号（支持跨组织）',
    selectOrgUser: '选择主题所属组织人员',
    confirmRevoke: '确认撤销该主题关系？'
  },
  management: {
    title: '组织管理',
    peopleManagement: '人员管理',
    visibleOrganizations: '可见组织',
    currentOrganization: '当前组织',
    addChild: '新增下级',
    organizationCode: '组织编码',
    level: '层级',
    path: '路径',
    childOrganizations: '下级组织',
    dragToSort: '拖动行调整同级顺序',
    saveOrder: '保存顺序',
    dragSort: '拖动排序',
    noChildren: '暂无下级组织',
    selectLeftOrganization: '请选择左侧组织',
    editTitle: '编辑组织',
    createTitle: '新增组织',
    organizationName: '组织名称',
    parentOrganization: '上级组织',
    autoGenerated: '系统自动生成',
    enterOrganizationName: '请输入组织名称',
    deleteConfirmMessage: '删除组织前请确认其中没有人员、设备和主题。',
    deleteConfirmTitle: '删除确认',
    deleteSuccess: '删除成功',
    orderSaved: '顺序已保存',
    moveParent: '调整上级',
    moveTitle: '调整组织上级',
    moveSource: '待调整组织',
    moveTarget: '新上级组织',
    moveTargetPlaceholder: '按组织名称过滤',
    selectedTarget: '已选上级',
    moveReason: '调整原因',
    moveReasonPlaceholder: '可选，填写本次调整原因',
    previewImpact: '预览影响',
    confirmMove: '确认调整',
    moveBlocked: '当前调整不可执行',
    moveSummary: '影响预览',
    currentPath: '当前路径',
    newPath: '调整后路径',
    nodes: '组织数',
    users: '人员数',
    boards: '设备数',
    themes: '主题数',
    affectedSubadmins: '受影响子管理员',
    selectMoveTarget: '请选择新的上级组织',
    moveConfirmMessage: '确认将该组织及全部下级组织移动到新的上级组织？人员、设备、主题归属和独立授权不会被改写。',
    moveSuccess: '组织上级调整成功'
  },
  users: {
    title: '组织人员',
    addUser: '新增人员',
    organizationScope: '组织范围',
    keywordPlaceholder: '登录名、昵称或手机号',
    accountStatus: '账号状态',
    changeOrganization: '调整组织',
    resetPassword: '重置密码',
    editTitle: '编辑人员',
    createTitle: '新增人员',
    password: '密码',
    keepPasswordPlaceholder: '不修改请留空',
    passwordPlaceholder: '请输入密码',
    confirmPassword: '确认密码',
    selectRole: '选择角色',
    dataScope: '数据范围',
    moveTitle: '调整人员组织',
    person: '人员',
    targetOrganization: '目标组织',
    detailsTitle: '人员详情',
    scopeCalculatedByServer: '由服务端按角色计算',
    selectTargetOrganization: '请选择目标组织',
    organizationChanged: '组织已调整',
    completeUserInfo: '请完整填写人员信息',
    saveFailed: '保存人员失败',
    passwordMismatch: '两次密码输入不一致',
    enterNewPassword: '请输入新密码',
    passwordMinLength: '密码至少6位',
    passwordResetSuccess: '密码已重置',
    disableConfirm: '禁用后该账号将不能登录，确认继续？',
    accountDisabled: '账号已禁用'
  },
  roles: {
    title: '角色与权限',
    builtinRoles: '内置角色',
    code: '编码',
    permissionPoints: '权限点',
    group: '分组',
    permissionCode: '权限编码',
    name: '名称',
    roleHasPermission: '角色已拥有',
    description: '说明'
  },
  myBoards: {
    title: '我的主板',
    owned: '自有',
    relationship: '关系',
    capability: '能力',
    operable: '可操作',
    noValidRelations: '暂无有效设备关系', renameTitle: '修改主板名称', nameRequired: '请输入主板名称', renamed: '主板名称已更新'
  },
  orgBoards: {
    internalUsers: "组织内人员",
    externalUsers: "外部协作",
    source: "授权来源",
    legacySource: "已有关系",
    permanent: "长期有效",
    expired: "已过期",
    editAuthorization: "编辑设备授权",
    exactPhone: "完整手机号（含国家区号，如 +86）",
    futureExpiry: "有效期必须晚于当前时间",
    confirmExternal: "确认将设备“{board}”授权给 {user}？权限：{permission}，有效期：{expiry}。已有授权将更新。",
    title: '组织设备',
    multipleOwners: '多个所有者',
    ownerUnavailable: '所有者不可用',
    managementCapability: '管理能力',
    userRelations: '人员关系',
    organizationAssignment: '组织归属',
    manageRelations: '管理关系',
    transferOwner: '转移所有者',
    relationsTitle: '设备人员关系',
    selectOrganizationUser: '选择组织内人员',
    transferOwnerTitle: '转移设备所有者',
    newOwner: '新所有者',
    selectDeviceOrgUser: '选择设备所属组织内人员',
    confirmTransfer: '确认转移',
    changeDeviceOrganization: '调整设备组织',
    confirmRevoke: '确认撤销该设备关系？',
    assignOrganizationFirst: '请先为设备分配所属组织',
    selectNewOwner: '请选择新所有者',
    ownerUpdated: '所有者已更新',
    organizationUpdated: '组织已更新', renameTitle: '修改主板名称', nameRequired: '请输入主板名称', renamed: '主板名称已更新'
  },
  platformBoards: {
    title: '平台设备运维',
    addDevice: '新增设备',
    taskLimit: '任务上限',
    sessionLimit: '场次上限',
    usedSessions: '已用场次',
    bootCount: '启动次数',
    autoUpgrade: '自动升级',
    platformValidity: '平台有效期',
    lastOnline: '最后在线',
    assignOwner: '指派所有者',
    reboot: '重启',
    refurbish: '翻新',
    editTitle: '编辑平台设备',
    createTitle: '新增平台设备',
    deviceDescription: '设备描述',
    maxTasks: '最大任务数',
    longTermPlaceholder: '不填写表示长期有效',
    enterChipId: '请输入芯片编号',
    enterDeviceName: '请输入设备名称',
    deviceUpdated: '设备已更新',
    deviceCreated: '设备已创建',
    enterTargetUserUid: '请输入目标用户 UID',
    assignOwnerTitle: '指派设备所有者',
    targetUserUidRequired: '目标用户 UID 不能为空',
    rebootConfirm: '确认重启该设备？',
    rebootSent: '重启指令已发送',
    refurbishConfirm: '翻新会清除设备关系、主题快照和运行记录，确认继续？',
    highRiskOperation: '高风险操作',
    deviceRefurbished: '设备已翻新',
    deleteConfirm: '删除会清除设备关系、主题快照和运行记录，确认继续？',
    deviceDeleted: '设备已删除',
    manageCapabilities: '主板能力授权',
    capabilityDescription: '仅允许被授权用户查看可运行期限并修改管理员参数，不会改变所有者或协作关系。',
    capabilityUser: '授权用户',
    capabilityType: '能力类型',
    boardAdminParamsCapability: '管理员参数能力',
    capabilityGranted: '能力已授权',
    revokeCapabilityConfirm: '确认收回该用户的主板管理员参数能力？'
  },
  deviceTypes: {
    controlV5: '主控板 V5',
    controlV3: '主控板 V3',
    SNA: 'SNA',
    SNIO: 'SNIO',
    SNU: 'SNU',
    phone: '电话'
  },
  roleNames: {
    sivaadmin: '系统管理员',
    admin: '系统管理员',
    subadmin: '子管理员',
    koradmin: '子管理员',
    store_manager: '店长',
    employee: '员工',
    platform_staff: '平台运维人员'
  },
  dataScopes: {
    ALL: '全部组织',
    ORG_AND_CHILDREN: '本组织及下级组织',
    SELF_ORG: '本组织'
  },
  permissionGroups: {
    org: '组织',
    user: '人员',
    board: '设备',
    platform: '平台',
    theme: '主题',
    role: '角色'
  },
  permissionNames: {
    org_view: '查看组织',
    org_create: '新增组织',
    org_update: '编辑组织',
    org_delete: '删除组织',
    org_sort: '组织排序',
    org_move: '调整组织上级',
    user_view: '查看人员',
    user_create: '新增人员',
    user_update: '编辑人员',
    user_delete: '删除人员',
    user_disable: '禁用人员',
    user_password_reset: '重置密码',
    user_role_set: '设置人员角色',
    user_org_move: '调整人员组织',
    board_own_view: '查看我的设备',
    board_org_view: '查看组织设备',
    board_org_set: '设置设备组织',
    board_user_set: '设置设备人员',
    board_external_share_set: '设备外部分享',
    board_owner_transfer: '转移设备所有者',
    board_capability_set: '设置主板能力',
    platform_board_ops: '平台设备运维',
    theme_view: '查看主题',
    theme_org_view: '查看组织主题',
    theme_edit: '编辑主题',
    theme_user_set: '设置主题人员',
    role_view: '查看角色',
    role_create: '新增角色',
    role_update: '编辑角色',
    role_delete: '删除角色',
    permission_view: '查看权限点'
  },
  permissionDescriptions: {
    org_view: '查看组织树',
    org_create: '新增组织',
    org_update: '修改组织信息',
    org_delete: '删除未被使用的组织',
    org_sort: '拖动调整同级组织顺序',
    org_move: '调整组织上级并更新下级路径',
    user_view: '查看组织范围内的人员',
    user_create: '在组织范围内新增人员',
    user_update: '修改组织范围内的人员',
    user_delete: '删除或禁用组织范围内的人员',
    user_disable: '禁止人员登录',
    user_password_reset: '重置人员密码',
    user_role_set: '分配人员角色',
    user_org_move: '调整人员所属组织',
    board_own_view: '查看自有和共享设备',
    board_org_view: '按组织范围查看设备',
    board_org_set: '设置设备所属组织',
    board_user_set: '设置设备人员关系',
    board_external_share_set: '按准确手机号分享设备',
    board_owner_transfer: '转移设备所有权',
    board_capability_set: '分配或收回独立主板能力',
    platform_board_ops: '执行平台级设备运维',
    theme_view: '按人员关系查看主题',
    theme_org_view: '按主题组织范围查看主题',
    theme_edit: '依据关系和权限编辑主题',
    theme_user_set: '设置主题人员关系',
    role_view: '查看角色',
    role_create: '新增自定义角色',
    role_update: '编辑自定义角色',
    role_delete: '删除自定义角色',
    permission_view: '查看权限点字典'
  }
}
